import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, polymorphicFactory, useProps } from "@coveord/plasma-mantine";
import { useEmptyStateContext } from "./EmptyStateContext.js";
var defaultProps = {};
export var EmptyStateBody = polymorphicFactory(function(_props, ref) {
    var ctx = useEmptyStateContext();
    var _ref = useProps("EmptyStateBody", defaultProps, _props), style = _ref.style, className = _ref.className, classNames = _ref.classNames, styles = _ref.styles, children = _ref.children, others = _object_without_properties(_ref, [
        "style",
        "className",
        "classNames",
        "styles",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles("body", {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others), {
        children: children
    }));
});

//# sourceMappingURL=EmptyStateBody.js.map